import Vue from 'vue'
import Vuex from 'vuex'
import authorization from './modules/authorization'
import packages from './modules/packages'
import commissionShipment from './modules/commissionShipment'
import houseShipment from './modules/houseShipment'
import ecr from './modules/ecr'

Vue.use(Vuex)

export const store =  new Vuex.Store({
  state: {
    screenWidth: null,
    mobile: null,
    tablet: null,
    desktop: null,
    largeDesktop: null,
    showMenu: true,
    socket: {
      message: '',
      connection: null
    }
  },
  getters: {},
  mutations: {
    updateScreenWidth (state, value) {
      state.screenWidth = value
    },
    updateMobile (state, value) {
      state.mobile = value
    },
    updateTablet (state, value) {
      state.tablet = value
    },
    updateDesktop (state, value) {
      state.desktop = value
    },
    updateLargeDesktop (state, value) {
      state.largeDesktop = value
    },
    toggleMenu (state) {
      state.showMenu = !state.showMenu
    },
    hideMenu (state) {
      state.showMenu = false
    },
    displayMenu (state) {
      state.showMenu = true
    },
    setConnection (state, data) {
      state.socket.connection = data
    },
    setMessage (state, data) {
      state.socket.message = data
    }
  },
  actions: {},
  modules: {
    authorization,
    packages,
    commissionShipment,
    houseShipment,
    ecr
  }
})
